/** Hedef kimliği. Yerleşik hedefler sabit kimlik taşır, eklenenler üretilir. */
export type LocationId = string;

/** "Tümü" görünümü: tek bir hedef yerine kayıtlı tüm hedefleri gösterir. */
export const ALL_TARGETS_ID = "tumu";

export interface TargetLocation {
  id: LocationId;
  /** Kısa etiket — seçim çubuğunda görünür. */
  name: string;
  /** Uzun ad — pusulanın altında görünür. */
  subtitle: string;
  lat: number;
  lon: number;
  /** true ise koordinat kesindir, kullanıcı düzenlemesine kapalıdır. */
  fixed?: boolean;
  /** true ise kullanıcı eklemiştir; silinebilir ve adı değiştirilebilir. */
  custom?: boolean;
}

/**
 * Varsayılan koordinatlar.
 *
 * Kâbe koordinatı sabittir. Diğer üç hedef kullanıcının verdiği noktalardır
 * ve uygulama içindeki Ayarlar ekranından değiştirilebilir (değer cihazda
 * saklanır).
 */
export const DEFAULT_LOCATIONS: TargetLocation[] = [
  {
    id: "kible",
    name: "Kıble",
    subtitle: "Kâbe-i Muazzama · Mekke",
    lat: 21.4224779,
    lon: 39.8251832,
    fixed: true,
  },
  {
    id: "kabri-serif",
    name: "Kabr-i Şerîf",
    subtitle: "Üsküdar · İstanbul",
    lat: 41.0098363,
    lon: 29.0236664,
  },
  {
    id: "kisikli",
    name: "Kısıklı",
    subtitle: "Kısıklı · Üsküdar · İstanbul",
    lat: 41.0215135,
    lon: 29.0624572,
  },
  {
    id: "umraniye",
    name: "Ümraniye",
    subtitle: "Ümraniye · İstanbul",
    lat: 41.0168977,
    lon: 29.0942149,
  },
];

export const DEFAULT_LOCATION_IDS = new Set(DEFAULT_LOCATIONS.map((l) => l.id));
